
import CheckCircleIcon from '@mui/icons-material/CheckCircleOutlined';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import { IconButton, Snackbar, SnackbarContent } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles(theme => ({
  content: {
    backgroundColor: theme.palette['header']?.dark,
  },
  error: {
    backgroundColor: theme.palette['error']?.dark,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.2em',
  },
  icon: {
    marginRight: theme.spacing(2),
  },
}));

const SuccessSnackbar = props => {
  const { open, messageText, error, onClose } = props;
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);


  const closeSnackbar = () => {
    setIsOpen(false);
    //onClose();
  };

  if (!error && !messageText) {
    return null;
  }

  return (
    <>
      {isOpen ?
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          autoHideDuration={6000}
          resumeHideDuration={2000}
          onClose={onClose}
          open={isOpen}
        >
          {error ? (
            <SnackbarContent
              className={classes.error}
              message={
                <span className={classes.message}>
                  <ErrorIcon className={classes.icon} />
                  {error}
                </span>
              }
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  className={classes.icon}
                  onClick={onClose}
                  size="large">
                  <CloseIcon />
                </IconButton>
              }
            />
          ) : messageText ? (
            <SnackbarContent
              className={classes.content}
              message={
                <span className={classes.message}>
                  <CheckCircleIcon className={classes.icon} />
                  {messageText}
                </span>
              }
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  className={classes.icon}
                  onClick={onClose}
                  size="large">
                  <CloseIcon />
                </IconButton>
              }
            />

          ) : null}
        </Snackbar> : null}
    </>
  );
};

SuccessSnackbar.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

SuccessSnackbar.defaultProps = {
  open: true,
  onClose: () => { }
};

export default SuccessSnackbar;
